import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=39e71abe&scoped=true&"
import script from "./DropdownMenu.vue?vue&type=script&lang=js&"
export * from "./DropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropdownMenu.vue?vue&type=style&index=0&id=39e71abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e71abe",
  null
  
)

export default component.exports